import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import DefaultButton from "../../../shared/components/DefaultButton";
import { loadEmployeeDataBySearchRequest } from "../../employees/redux/Actions"
import { loadGroupMemberAddDataRequest } from "../redux/Actions";
import { Alert } from "react-bootstrap";

const AddMembers = ({ groupMembers, selectedRow, onClose, onMembersAdded }) => {
  
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMembers, setSelectedMembers] = useState(new Set());
  const dispatch = useDispatch();
  let empSearch = useSelector((state) => state.employee.empSearch);
  let addMember = useSelector((state) => state.chatgroup);
  const [feedbackMessage, setFeedbackMessage] = useState(null);
const [feedbackType, setFeedbackType] = useState(null); // 'success' or 'error'

  console.log("Employees", groupMembers, selectedRow);  
  // let employee_id = empSearch.map(emp => emp.employee_id);
  // console.log("Employee Id", employee_id);

  useEffect(() => {
     {
      dispatch(loadEmployeeDataBySearchRequest({ searchby: "" }));
    }
  }, []);  
  
  //get initials 
  const getInitials = (firstName, lastName) => {if (!firstName && !lastName) return "N/A";
    return `${firstName?.charAt(0) || ""}${lastName?.charAt(0) || ""}`.toUpperCase();
  };
  
  // Function to generate a random hex color
  const getRandomColor = () => {
     return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  };


  // Filter employees based on search term
  const filteredMembers = empSearch.filter((employee) => {
    const fullName = `${employee.first_name} ${employee.last_name}`.toLowerCase();
    const empId = String(employee.employee_id).toLowerCase();
    const search = searchTerm.toLowerCase();
    return fullName.includes(search) || empId.includes(search);
  });

  // Toggle selection of employee
  const handleCheckboxChange = (id) => {
    console.log("IDDD",id);    
    setSelectedMembers((prev) => {
      const newSet = new Set(prev);
      newSet.has(id) ? newSet.delete(id) : newSet.add(id);      
      return newSet;
    });
   
  };

  const handleAddMembers = (selectedMembers) => {
    let employees = Array.from(selectedMembers);
   // console.log("Members:", Array.from(selectedMembers));
   // console.log("Chat Id", selectedRow.data.id);

    let request = {
      "chatId": selectedRow.data.id ,
      "participants": employees
  };
  console.log("Reqqq", request);
  dispatch(loadGroupMemberAddDataRequest(request));
  
  };


  useEffect(() => {
    if (addMember.addmembers) {
      const { newlyAddedParticipants, reactivatedParticipants, invalidParticipants, alreadyExistingParticipants } = addMember.addmembers;
  
      if (invalidParticipants?.length > 0) {
        setFeedbackMessage("Invalid participants");
        setFeedbackType("error");
      }
  
      if (alreadyExistingParticipants?.length > 0) {
        setFeedbackMessage("Already Existing participants");
        setFeedbackType("error");
      }
  
      if (newlyAddedParticipants?.length > 0 || reactivatedParticipants?.length > 0) {
        setFeedbackMessage("Newly added members");
        setFeedbackType("success");
  
        // Close popup
       // if (onClose) onClose();
  
        // Inform parent to update member list
        if (onMembersAdded) onMembersAdded(newlyAddedParticipants);
      }
    }
  }, [addMember.addmembers]);
  
  

  return (
    <div>
      {/* Title */}
          <h5 style={{ marginBottom: "10px", color: "#333" }}>Add Members</h5>

      {/* Add Button */}
            <DefaultButton
                buttonClass={"default-btn-color me-1"}
                buttonTitle={"Add Members"}
                actionBlock={() => handleAddMembers(selectedMembers)}
            />
                {feedbackMessage && (
            <div
              style={{
                marginBottom: "10px",
                padding: "10px",
                borderRadius: "4px",
                color: feedbackType === "error" ? "#842029" : "#0f5132",
                backgroundColor: feedbackType === "error" ? "#f8d7da" : "#d1e7dd",
                border: `1px solid ${feedbackType === "error" ? "#f5c2c7" : "#badbcc"}`
              }}
            >
              {feedbackMessage}
            </div>
          )}


       {/* Selected Members Display */}
           <div style={{ margin: "10px 0", padding: "10px", backgroundColor: "#f1f1f1", borderRadius: "5px" }}>
            {[...selectedMembers].map((id) => 
                  {
                      const emp = empSearch.find((e) => e.employee_id === id);
                      return emp ? `${emp.first_name} ${emp.last_name} (${emp.employee_id})` : "";
                  }).filter((entry) => entry !== "").join(", ") || <span style={{ color: "#888" }}>No members selected</span>}

            </div>
      {/* Search Bar */}
             <Form.Control type="text" placeholder="Search members..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="mb-2" />

      {/* Display Employees */}
              <div style={{ marginBottom: "15px", minHeight: "300px"  }}>
                  {filteredMembers.length > 0 ? (
                    filteredMembers.map((employee) => {
                    // console.log("Emppp",employee);
                      const color = getRandomColor(); // Get color from function
                      return (
                        <div key={employee.id} style={{display: "flex",alignItems: "center",padding: "10px",borderBottom: "1px solid #eee",transition: "background-color 0.3s ease",}}
                          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9f9f9")}
                          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                        >
       {/* Checkbox */}
              <input type="checkbox" checked={selectedMembers.has(employee.employee_id)} onChange={() => handleCheckboxChange(employee.employee_id)}  style={{ marginRight: "10px" }}/>

        {/* Profile Icon */}
                <div style={{width: "35px",height: "35px",borderRadius: "50%",backgroundColor: color,color: "#fff",display: "flex",justifyContent: "center", alignItems: "center",fontWeight: "bold",marginRight: "10px",textTransform: "uppercase", }} >
                  {getInitials(employee.first_name, employee.last_name)}
                </div>

        {/* Name and Email */}
                <div>
                  <span style={{ fontSize: "15px" }}>
                    {employee.first_name} {employee.last_name}{","}     {employee.employee_id }
                  </span>
                  <br />
                  {/* <span style={{ fontSize: "10px", color: "#666" }}>
                    {employee.email || "No email provided"}
                  </span> */}
                </div>
              </div>
            );
          })
        ) : (
          <p style={{ color: "#888", fontStyle: "italic" }}>No matching members</p>
        )}
      </div>
      
        
    </div>
  );
};

export default AddMembers;
